<template>
  <footer class="paginacao">
    <span>
      Exibindo {{ inicioPagina }}–{{ fimPagina }} de {{ totalElementos }}
    </span>
    <div>
      <button
        type="button"
        :disabled="paginaAtual === 0"
        aria-label="Página anterior"
        title="Página anterior"
        @click="emit('mudar-pagina', paginaAtual - 1)"
      >
        ‹
      </button>
      <span>Página {{ paginaAtual + 1 }} de {{ totalPaginas }}</span>
      <button
        type="button"
        :disabled="paginaAtual >= totalPaginas - 1"
        aria-label="Próxima página"
        title="Próxima página"
        @click="emit('mudar-pagina', paginaAtual + 1)"
      >
        ›
      </button>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  paginaAtual: { type: Number, required: true },
  totalPaginas: { type: Number, required: true },
  totalElementos: { type: Number, required: true },
  tamanhoPagina: { type: Number, default: 6 },
});

const emit = defineEmits(['mudar-pagina']);

const inicioPagina = computed(() =>
  props.totalElementos ? props.paginaAtual * props.tamanhoPagina + 1 : 0
);

const fimPagina = computed(() =>
  Math.min((props.paginaAtual + 1) * props.tamanhoPagina, props.totalElementos)
);
</script>

<style scoped>
/* ==================== PAGINAÇÃO ==================== */
.paginacao,
.paginacao > div {
  display: flex;
  align-items: center;
}

.paginacao {
  justify-content: space-between;
  gap: 16px;
  padding: 14px 4px 0 4px;
  border-top: 1px solid hsl(258, 25%, 92%);
  color: var(--cinza-medio, hsl(215, 15%, 50%));
  font-size: 0.78rem;
  margin-top: 4px;
  width: 100%;
}

.paginacao > div {
  gap: 9px;
}

.paginacao button {
  width: 32px;
  height: 32px;
  border: 1px solid var(--roxo-superficie, hsl(258, 25%, 88%));
  border-radius: 8px;
  color: var(--roxo-medio, var(--roxo-claro, #6f319e));
  background: var(--branco, #ffffff);
  font-size: 1.1rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  line-height: 1;
}

.paginacao button:hover:not(:disabled) {
  border-color: var(--roxo-claro, #6f319e);
  background: hsl(258, 45%, 96%);
  transform: translateY(-1px);
}

.paginacao button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
}
</style>
